module.exports = __webpack_public_path__ + "img/el-salvador.1b29ca9e.svg";